export enum WayToPetInfo {
  ai = 'ai',
  manual = 'manual',
}
